import React from 'react';
import createReactClass from 'create-react-class';
import _ from 'underscore';

var MetadataFilter = createReactClass({

    getInitialState: function () {
        return {
            term: this.props.value || '',
            didSetTypingStatus: false
        };
    },

    componentWillMount: function () {
        this.updateParent = _.debounce(this.updateParent, 700);
    },

    updateParent: function () {
        this.setState({
            didSetTypingStatus: false
        });
        this.props.termChanged(this.state.term);
    },

    handleTermChange: function (event) {
        if (this.props.noDebounce) return this.props.termChanged(event.target.value);

        this.setState({
            term: event.target.value,
            didSetTypingStatus: true
        });
        if (!this.state.didSetTypingStatus) this.props.isTyping();
        this.updateParent();
    },

    render: function () {
        return (
            <div className="input-group">
                <span className="input-group-addon"><i className="fa fa-filter"/></span>
                <input type="text" ref="listingFilter" className="form-control" placeholder="Filter &hellip;" value={this.props.noDebounce ? this.props.value : this.state.term} onChange={this.handleTermChange}/>
            </div>
        );
    }
});

export default MetadataFilter;
